// extracted by mini-css-extract-plugin
export var numpadContainer = "_sq-1";
export var phoneButton = "_sq-0";